/**
 * The course manifest: the one place that lists the modules, in order.
 */

import { type Course, COURSE_ID } from "@/features/training/types";

import { MODULE as WELCOME } from "./modules/01-welcome";
import { MODULE as QUEUE } from "./modules/02-queue";
import { MODULE as CUSTOMER } from "./modules/03-customer";
import { MODULE as LINES } from "./modules/04-lines";
import { MODULE as PRICES } from "./modules/05-prices";
import { MODULE as REPLY } from "./modules/06-reply";
import { MODULE as STATUS } from "./modules/07-status";
import { MODULE as EXTRAS } from "./modules/08-extras";
import { MODULE as QUIZ } from "./modules/09-quiz";
import { MODULE as CLOSING } from "./modules/10-closing";

export const COURSE: Course = {
  id: COURSE_ID,
  title: "I2Q for sales",
  subtitle:
    "Find, check and reply to inquiries with I2Q. About 23 minutes, or 5 for the quick start.",
  // 2: the minimal redesign of 12 Oct 2026 (three steps, one word per row, one action).
  contentVersion: 2,
  modules: [WELCOME, QUEUE, CUSTOMER, LINES, PRICES, REPLY, STATUS, EXTRAS, QUIZ, CLOSING],
};
